module.exports = __webpack_public_path__ + "static/img/placeholder.59e6f5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/placeholders/placeholder.png
// module id = 2xI6
// module chunks = 31